import { EntityType } from "handlers";

export function isNewClientUpdate(clientUpdateId: number) {
    return clientUpdateId === 0;
}

export function getEntityNameFromEntityType(entityType: EntityType): string {
    switch (entityType) {
        case EntityType.BidPackage:
            return "Bid Package";
        case EntityType.ChangeOrder:
            return "Change Order";
        case EntityType.DailyLog:
            return "Daily Log";
        case EntityType.OwnerInvoice:
            return "Invoice";
        case EntityType.PlanSet:
            return "Plan Set";
        case EntityType.ProposalFormatItem:
            return "Estimate Line Item";
        case EntityType.PurchaseOrder:
            return "Purchase Order";
        case EntityType.Selection:
            return "Selection";
        case EntityType.SelectionOptions:
            return "Selection Option";
        case EntityType.Specification:
            return "Specification";
        case EntityType.Todo:
            return "To-do";
        case EntityType.Schedule:
            return "Schedule item";
        default:
            return "Item";
    }
}
